"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _excluded = ["className", "bordered", "type", "option", "display"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Option = _antd.Select.Option,
    OptGroup = _antd.Select.OptGroup;

var SelectWrapper = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  .primary {\n    &.ant-select-single {\n      background-color: ", ";\n      width: 100%;\n      border-radius: 2px;\n      font-size: ", ";\n      color: ", ";\n      transition: 0.3s;\n      &:not(.ant-select-disabled) {\n        &:hover,\n        &:focus {\n          background-color: ", ";\n        }\n        &:active {\n          background-color: ", ";\n          color: ", ";\n          .ant-select-arrow {\n            color: ", ";\n          }\n        }\n        .ant-select-arrow {\n          color: ", ";\n        }\n      }\n      &.ant-select-disabled {\n        .ant-select-selector,\n        .ant-select-arrow {\n          color: ", ";\n        }\n      }\n      &:not(.ant-select-customize-input) {\n        .ant-select-selector {\n          height: 28px;\n          padding: 0 4px;\n          border: 0;\n        }\n      }\n      .ant-select-selection-item {\n        line-height: 28px;\n        padding-right: 20px;\n      }\n      .ant-select-arrow {\n        right: 5px;\n        font-size: ", ";\n        margin-top: -7px;\n      }\n      &.ant-select-open {\n        .ant-select-selection-item {\n          color: ", ";\n        }\n      }\n      /* &.ant-select-open,*/\n      &.ant-select-open {\n        background-color: ", ";\n        color: ", ";\n        .ant-select-arrow {\n          color: ", ";\n        }\n        &:hover,\n        &:focus,\n        &:active {\n          background-color: ", ";\n          color: ", ";\n          .ant-select-arrow {\n            color: ", ";\n          }\n        }\n      }\n    }\n  }\n"])), _theme.theme.rgba.transparent, _theme.theme.font_size.size_xl, _theme.theme.colors.blue_primay, _theme.theme.rgba.menuactive, _theme.theme.rgba.menuactive, _theme.theme.colors.blue_primay, _theme.theme.colors.blue_primay, _theme.theme.colors.blue_primay, _theme.theme.colors.grey_stone, _theme.theme.font_size.size_m, _theme.theme.colors.blue_primay, _theme.theme.colors.transparent, _theme.theme.colors.blue_primay, _theme.theme.colors.blue_tertiary, _theme.theme.rgba.menuactive, _theme.theme.colors.blue_primay, _theme.theme.colors.blue_primay);

var SelectComponent = function SelectComponent(props) {
  var className = props.className,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? false : _props$bordered,
      _props$type = props.type,
      type = _props$type === void 0 ? "primary" : _props$type,
      _props$option = props.option,
      option = _props$option === void 0 ? null : _props$option,
      _props$display = props.display,
      display = _props$display === void 0 ? null : _props$display,
      rest = _objectWithoutProperties(props, _excluded);

  var keys = display === "groupBy" && Object.keys(option);
  return /*#__PURE__*/_react.default.createElement(SelectWrapper, null, /*#__PURE__*/_react.default.createElement(_antd.Select, _extends({
    className: "".concat(type),
    bordered: bordered,
    type: type
  }, rest), display === "groupBy" ? keys.map(function (val, index) {
    return /*#__PURE__*/_react.default.createElement(OptGroup, {
      label: "".concat(keys[index]),
      key: index
    }, option[val].map(function (optionVal) {
      return /*#__PURE__*/_react.default.createElement(Option, {
        value: optionVal,
        key: optionVal
      }, optionVal);
    }));
  }) : option && option.map(function (val) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: val.value,
      key: val.value
    }, val.label);
  })));
};

var _default = SelectComponent;
exports.default = _default;